/* ZETAW — "See more" for the collection grid: the page opens with a few pieces,
   the button pulls the next page into the same grid (same filters / sort), no page reload. */
(function(){
  'use strict';
  var CSS = '.zlm{display:flex;flex-direction:column;align-items:center;gap:10px;padding:26px 16px 10px;font-family:"Bebas Neue",Impact,"Arial Narrow",sans-serif;text-transform:uppercase}' +
    '.zlm button{position:relative;display:inline-flex;align-items:center;gap:10px;background:#0a0a0a;color:#f0ece3;border:1px solid #3a3935;padding:13px 22px 10px;font:inherit;font-size:20px;letter-spacing:.16em;cursor:pointer;border-radius:0;overflow:hidden}' +
    '.zlm button:hover{border-color:#f0ece3}' +
    '.zlm button:focus-visible{outline:2px solid #f0ece3;outline-offset:3px}' +
    '.zlm button i{width:7px;height:7px;border-radius:50%;background:#c7412f;animation:zlmB 1.1s steps(1) infinite}' +
    '.zlm button::after{content:"";position:absolute;top:0;bottom:0;left:-40%;width:40%;background:linear-gradient(90deg,transparent,rgba(240,236,227,.22),transparent);opacity:0}' +
    '.zlm button.is-busy{cursor:progress;border-color:#f0ece3}' +
    '.zlm button.is-busy::after{opacity:1;animation:zlmS .6s linear infinite}' +
    '.zlm small{font-size:14px;letter-spacing:.16em;opacity:.6}' +
    '.zlm-hide{display:none!important}' +
    '@keyframes zlmB{50%{opacity:.15}}@keyframes zlmS{to{transform:translateX(350%)}}' +
    '@media (prefers-reduced-motion:reduce){.zlm button i,.zlm button.is-busy::after{animation:none}}';

  function pageOf(href){ try { return parseInt(new URL(href, location.href).searchParams.get('page'), 10) || 1; } catch (e) { return 1; } }

  function setup(){
    var grid = document.getElementById('product-grid');
    if (!grid || grid.tagName !== 'UL' || grid._zlm) return;
    grid._zlm = true;
    var box = grid.closest('.collection') || grid.parentNode;
    var pag = box.querySelector('.pagination-wrapper, nav.pagination, .pagination');
    if (!pag) return;                                   /* one page only: nothing to add */
    var links = Array.prototype.slice.call(pag.querySelectorAll('a[href]'));
    var total = links.reduce(function(m, a){ return Math.max(m, pageOf(a.getAttribute('href'))); }, pageOf(location.href));
    var page = pageOf(location.href);
    if (page >= total) return;
    var cfg = document.querySelector('[data-zetaw-cwarp]');
    var label = (cfg && cfg.dataset.moreLabel) || 'See more';
    var totalCount = (cfg && cfg.dataset.total) || '';
    pag.classList.add('zlm-hide');

    var wrap = document.createElement('div'); wrap.className = 'zlm';
    wrap.innerHTML = '<button type="button"><i aria-hidden="true"></i><span></span></button><small aria-live="polite"></small>';
    box.appendChild(wrap);
    var btn = wrap.querySelector('button'), txt = btn.querySelector('span'), meta = wrap.querySelector('small');
    function refresh(){
      var shown = grid.children.length;
      txt.textContent = label + ' ↓';
      meta.textContent = shown + (totalCount ? ' / ' + totalCount : '') + ' pieces on screen';
    }
    refresh();

    btn.addEventListener('click', function(){
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy'); txt.textContent = 'Pulling files…';
      var u = new URL(location.href);
      u.searchParams.set('page', page + 1);
      u.searchParams.set('section_id', grid.dataset.id);
      fetch(u.toString(), { credentials: 'same-origin' }).then(function(r){ return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('product-grid');
        var items = ng ? ng.children : [];
        var frag = document.createDocumentFragment(), first = null;
        Array.prototype.slice.call(items).forEach(function(li){
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          var node = document.importNode(li, true);
          if (!first) first = node;
          frag.appendChild(node);
        });
        grid.appendChild(frag);
        page++;
        btn.classList.remove('is-busy');
        refresh();
        if (!ng || !items.length || page >= total){ wrap.remove(); }
        if (first){ var a = first.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
      }).catch(function(){
        /* network trouble: fall back to the normal next page */
        var n = new URL(location.href); n.searchParams.set('page', page + 1); location.href = n.toString();
      });
    });
  }

  function boot(){
    if (!document.getElementById('zlm-css')){ var st = document.createElement('style'); st.id = 'zlm-css'; st.textContent = CSS; document.head.appendChild(st); }
    setup();
    /* filters / sort re-render the grid: set the button up again */
    var box = document.getElementById('ProductGridContainer');
    if (box && 'MutationObserver' in window){
      var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(setup, 60); }).observe(box, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
